import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from 'process';
import { environment } from 'src/environments/environment';
const LOCALHOST = 'http://localhost:3800';
@Injectable({
  providedIn: 'root'
})
export class NotesService {
  private api = environment.api+'/api/notes';
  private _notesStatus: any[];
  constructor(
    private http: HttpClient
  ) { }

  getNotes(_status?,_dateStart?,_dateEnd?,_email?) {
    return this.http.post(this.api + '/getAll', {
      status: _status,
      dateStart: _dateStart,
      dateEnd: _dateEnd,
      email: _email
    });
  }
  getNoteDetail(_idNote) {
    return this.http.post(this.api + '/getNoteDetail', {
      idNote: _idNote
    });
  }
  async getNotesStatus(request?) {
    try {
      if(request || !this._notesStatus) {
        await this.http.get(this.api + '/status').toPromise()
        .then((res: any) => {
          if(res && res.data) {
            this._notesStatus = res.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
      }
      return this._notesStatus;
    } catch(err) {
      console.log(err);
      return [];
    }
  }

  addResponse(_noteResponse) {
    return this.http.post(this.api + '/response/add', {
      note: _noteResponse
    });
  }

  updateStatus(_idNote, _status) {
    return this.http.post(this.api + '/updateStatus', {
      idNote: _idNote,
      status: _status
    });
  }
}
